export default __webpack_public_path__ + "static/media/Dickcraft.56cbd8db.PNG";